import React from 'react';
import { Box, styled, keyframes } from '@mui/material';

const l18 = keyframes`
  0%   { background-position: 50% 50%, 50% 50%, 50% 50%, 50% 50%, 50% 50%; transform: rotate(0deg) scale(1); }
  25%  { background-position: 0 100%, 100% 0, 50% 50%, 50% 50%, 50% 50%; transform: rotate(5deg) scale(1.05); }
  50%  { background-position: 0 100%, 100% 0, 100% 100%, 0 0, 50% 50%; transform: rotate(0deg) scale(1.1); }
  75%  { background-position: 50% 50%, 50% 50%, 100% 100%, 0 0, 50% 50%; transform: rotate(-5deg) scale(1.05); }
  100% { background-position: 50% 50%, 50% 50%, 50% 50%, 50% 50%, 50% 50%; transform: rotate(0deg) scale(1); }
`;

const glow = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderOverlay = styled(Box)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
    backdropFilter: 'blur(3px)',
});

const AnimatedBox = styled(Box)({
    width: '70px',
    aspectRatio: '1',
    position: 'relative',
    background: `
    linear-gradient(45deg, #60B99A 50%, #0000 0),
    linear-gradient(45deg, #0000 50%, #60B99A 0),
    linear-gradient(-45deg, #f77825 50%, #0000 0),
    linear-gradient(-45deg, #0000 50%, #f77825 0),
    linear-gradient(#554236 0 0)
  `,
    backgroundSize: '50% 50%',
    backgroundRepeat: 'no-repeat',
    animation: `${l18} 4s infinite cubic-bezier(0.3, 1, 0.7, 1)`,
    filter: 'drop-shadow(0 0 12px rgba(96, 185, 154, 0.3))',

    '&::before': {
        content: '""',
        position: 'absolute',
        inset: '-4px',
        borderRadius: '8px',
        background: 'conic-gradient(from 45deg, #60B99A00, #60B99A, #f7782500, #f77825, #60B99A00)',
        filter: 'blur(12px)',
        opacity: 0.4,
        animation: `${glow} 8s linear infinite`,
    },
});

const Loader = () => {
    return (
        <LoaderOverlay>
            <AnimatedBox />
        </LoaderOverlay>
    );
};

export default Loader;